export default __webpack_public_path__ + "static/media/mask.78bf6bba.svg";